import React, { memo } from 'react'
import { Path, Circle as _Circle } from 'react-native-svg'

import { IconProps } from '../IconProps'
import { IconBase } from '../IconBase'
import { themed } from '../themed'

const Icon = (props) => {
  const { color = 'black', size = 24, ...otherProps } = props
  return (
    <IconBase
      width={size}
      height={size}
      viewBox="0 0 27 27"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <Path
        d="M18.563 4.5c-1.958 0-3.837.911-5.063 2.351C12.274 5.411 10.395 4.5 8.437 4.5c-3.464 0-6.187 2.723-6.187 6.188 0 4.252 3.825 7.717 9.619 12.982l1.631 1.474 1.631-1.485c5.794-5.254 9.619-8.719 9.619-12.971 0-3.466-2.723-6.188-6.188-6.188Z"
        fill={`${color}`}
      />
    </IconBase>
  )
}

Icon.displayName = 'IconHeartFull'

export const IconHeartFull = memo<IconProps>(themed(Icon))
